import type { DeleteSwatchConfirmationModalProps } from "@v1/types/modalTypes";

import * as React from "react";

import { swatchRouter, swatchUtils } from "@v1/trpc/routes/swatch";
import DeleteConfirmationModal from "@v2/components/DeleteConfirmationModal";
import useCurrentProjectId from "@v2/hooks/useCurrentProjectId";
import { useModal } from "@v2/store/modalStore";

export const DeleteSwatchConfirmationModal = ({
  swatchName,
  swatchId,
  onDelete,
}: DeleteSwatchConfirmationModalProps) => {
  const modal = useModal();
  const projectId = useCurrentProjectId()!;

  const { mutateAsync: deleteSwatchAsync, status } =
    swatchRouter.delete.useMutation({
      onSuccess: async () => {
        void swatchUtils.list.invalidate({ projectId });
      },
    });

  const handleDelete = () => {
    void deleteSwatchAsync({ swatchId, projectId });
    modal.closeModal({});
    onDelete?.();
  };

  return (
    <DeleteConfirmationModal
      onRequestClose={() => {
        return modal.closeModal({ type: "deleteSwatchConfirmationModal" });
      }}
      onDelete={handleDelete}
      assetTypeDisplayName="Swatch"
      assetName={swatchName}
      isLoading={status === "pending"}
    />
  );
};
